import { fetchCreatedQuoteRateResults } from '@/modules/spot-quote/data-provider/create-quote-rate-results/data-provider';
import { useQuery } from '@tanstack/react-query';

export const useGetCreateQuoteRateResults = (encodedKey: string) => {
  return useQuery({
    queryKey: ['cached-quote-rate-results', encodedKey],
    queryFn: () => fetchCreatedQuoteRateResults(encodedKey),
    staleTime: 1000 * 60 * 5,
    enabled: !!encodedKey,
  });
};
